import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Vue from 'vue';
import { IConfig } from '../shared/contracts/ConfigContract';

function sentryBuilder(config: IConfig) {
    if (config.UI_SENTRY_IO_URL) {
        Raven.config(config.UI_SENTRY_IO_URL, { environment: config.SENTRY_ENVIRONMENT })
            .addPlugin(RavenVue, Vue)
            .install();
    }
}

export default sentryBuilder;
